import {
  CurrentSubscriptionResource,
  currentSubscriptionResourceSchema,
} from "@client/resources/CurrentSubscriptionResource";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import { object } from "yup";

export type FetchCurrentSubscriptionResponse =
  ApiResponse<CurrentSubscriptionResource | null>;

const schema = object({
  data: currentSubscriptionResourceSchema.nullable().default(null),
});

export const fetchCurrentSubscription =
  async (): Promise<FetchCurrentSubscriptionResponse> => {
    const response = await fetchData(
      "/dietitian/subscription/current",
      APIMethods.GET,
    );

    return await schema
      .validate(response)
      .catch(logFetchValidateError("/dietitian/subscription/current"));
  };
